import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const AwardsRoute = lazyWithRetries(() => import('./'))
const ViewAwardRoute = lazyWithRetries(() => import('./viewAward'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.awards(),
    element: (
      <StandardPageLayout elementId="awardsRoute" title={<T _str="Awards" />} maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <AwardsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.viewAward(':id'),
    element: (
      <StandardPageLayout elementId="viewAwardRoute" title={<T _str="Award" />} maxWidth={600}>
        <Suspense fallback={<RouteLoading />}>
          <ViewAwardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
